import React from 'react';
const EstateAgent = () => <div className="service-page"><h1>Estate Agents</h1><p>Expert estate agents for all your property needs.</p></div>;
export default EstateAgent;
